/**
 * Browser privacy signals that gate analytics.
 *
 * The Privacy Policy says we honour Global Privacy Control as an opt-out of
 * analytics, so this has to be the thing that actually enforces it. GPC is what
 * Firefox's "Tell websites not to sell or share my data", Brave, and the
 * DuckDuckGo extension set, and several state privacy laws treat it as a valid
 * opt-out request — so a visitor sending it never gets PostHog, GA4, or
 * Clarity loaded at all, rather than being loaded and then suppressed.
 *
 * Deliberately not keyed off legacy DNT: it was never a legal signal and
 * browsers set it inconsistently.
 */

export const analyticsOptedOut = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return (
    (navigator as Navigator & { globalPrivacyControl?: boolean })
      .globalPrivacyControl === true
  );
};
